import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { draftACampaign } from 'src/common/Scraper';
import { CitationSiteType } from '../types';


interface IAvailableCitation {
    citationSite: string;
    citationSiteType: CitationSiteType;
}


export interface IDraftACampaignProps {
  campaign_id: string;
  existingCitations: string[];
  availableCitations: IAvailableCitation[];
}

export interface IDraftACampaignResponse {
  status: string;
  message: string;
  response: any;
}

export const useDraftACampaign = (): UseMutationResult<
  IDraftACampaignResponse,
  AxiosError,
  IDraftACampaignProps
> => {
  return useMutation<IDraftACampaignResponse, AxiosError, IDraftACampaignProps>({
    mutationFn: draftACampaign,
  });
};
